// src/hooks/hotelMealPlans/useForceDeleteHotelMealPlan.js
import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { forceDeleteHotelMealPlan as forceDeleteHotelMealPlanAPI } from "../../api/apiHotelMealPlans";
import parseError from "../../utils/parseError";

const useForceDeleteHotelMealPlan = () => {
    const queryClient = useQueryClient();

    const { mutate: forceDelete, isPending: isForceDelete } = useMutation({
        mutationFn: forceDeleteHotelMealPlanAPI,
        onSuccess: (res) => {
            const message = res?.message || "Hotel meal plan permanently deleted";
            toast.success(message);
            queryClient.invalidateQueries({ queryKey: ["hotelMealPlans"] });
        },
        onError: (error) => {
            const msg = parseError(error);
            toast.error(msg || "Failed to permanently delete hotel meal plan");
        },
    });

    return { forceDeleteHotelMealPlan: forceDelete, isForceDelete };
};

export default useForceDeleteHotelMealPlan;
